/**
 * Triggers a browser download for an in-memory blob. Shared by ExportModal
 * and any screen that generates a file client-side (e.g. Reports).
 */
export function saveBlob(blob, filename) {
	const url = URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	link.download = filename;
	document.body.appendChild(link);
	link.click();
	link.remove();
	URL.revokeObjectURL(url);
}
